import {Input, InputProps} from "@chakra-ui/react";
import {BaseControl, BaseControlProps} from "../BaseControl";

interface BaseInputProps extends BaseControlProps, InputProps {
    inputMode?: React.HTMLAttributes<HTMLInputElement>["inputMode"];
    pattern?: string;
}

export const BaseInput = (props: BaseInputProps) => {
    const {value, name, onChange } = props;
    return (
        <BaseControl {...props}>
            <Input
                border="1px solid"
                borderColor="gray.200"
                borderRadius="lg"
                bgColor="white"
                type="text"
                maxW="100%"
                id="expected_position"
                value={value}
                onChange={onChange}
                name={name}
                inputMode={(props as any).inputMode}
                pattern={(props as any).pattern}
                fontSize="sm"
                color="gray.700"
                _hover={{
                    borderColor: "blue.400",
                }}
                _focus={{
                    borderColor: "blue.500",
                    boxShadow: "0 0 0 2px rgba(66, 153, 225, 0.2)",
                }}
                _placeholder={{
                    color: "gray.400",
                    fontSize: "sm",
                }}
                _invalid={{
                    borderColor: "red.500",
                    boxShadow: "0 0 0 1px red.500",
                }}
                transition="all 0.2s ease-in-out"
                {...props}
            />
        </BaseControl>
    );
};
